export const BASE_RATES_UPDATE_LUNCH_GRID_DATA =
  'BASE_RATES_UPDATE_LUNCH_GRID_DATA';
export const BASE_RATES_UPDATE_BREAKFAST_GRID_DATA =
  'BASE_RATES_UPDATE_BREAKFAST_GRID_DATA';
export const BASE_RATES_UPDATE_SITE = 'BASE_RATES_UPDATE_SITE';
export const BASE_RATES_ERROR = 'BASE_RATES_ERROR';
export const BASE_RATES_LOADING = 'BASE_RATES_LOADING';
export const BASE_RATES_UPDATE_FISCAL_YEAR = 'BASE_RATES_UPDATE_FISCAL_YEAR';
export const BASE_RATES_SET_SUCCESSFUL = 'BASE_RATES_SET_SUCCESSFUL';
export const BASE_RATES_UPDATE_OTHER_FISCAL_YEAR =
  'BASE_RATES_UPDATE_OTHER_FISCAL_YEAR';
export const BASE_RATES_UPDATE_SET_TOGGLE = 'BASE_RATES_UPDATE_SET_TOGGLE';
export const BASE_RATES_UPDATE_OTHER_FISCAL_YEARS =
  'BASE_RATES_UPDATE_OTHER_FISCAL_YEARS';



// WEBPACK FOOTER //
// ./src/pages/provision2baseratessetup/state/provision2BaseRatesSetup/types.js